import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, Users, ShieldCheck, Lock, CreditCard } from 'lucide-react';
export const Hero = () => {
  return <section className="relative pt-12 pb-10 md:pt-28 md:pb-20 overflow-hidden bg-offwhite" data-id="element-151">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-152">
        <div className="flex flex-col items-center lg:grid lg:grid-cols-2 lg:gap-12 lg:items-center" data-id="element-153">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-center lg:text-left w-full" data-id="element-154">
            <div className="inline-block mb-3 px-3 py-1 bg-sage-100 text-sage-700 rounded-full text-[10px] font-semibold tracking-wide uppercase" data-id="element-155">
              PILATES 360 MegaPack — Sistema Completo
            </div>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-charcoal leading-tight mb-4" data-id="element-156">
              Todo tu año de{' '}
              <span className="text-sage" data-id="element-157">Pilates resuelto.</span>
            </h1>

            {/* Mockup image — inline on mobile, hidden on desktop (shown in right column) */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} className="relative my-6 lg:hidden" data-id="element-158">
              <div className="absolute inset-0 bg-sage-200 rounded-full blur-3xl opacity-30" data-id="element-159"></div>
              <img src="https://cdn.magicpatterns.com/uploads/qgYL8YsPZ4NwKd6D4QHx5S/hf_20260408_025308_a29afd08-5343-4eda-a650-8ce65bca8982-Photoroom.png" alt="Pilates 360 MegaPack Mockup" className="relative z-10 w-[70%] max-w-[280px] mx-auto drop-shadow-2xl" data-id="element-160" />
            </motion.div>

            <p className="md:text-2xl text-gray-600 mb-2 font-playfair italic text-[16px]" data-id="element-161">
              6 Tomos · 60+ Clases · 6 Bonos · Listo para usar.
            </p>
            <p className="text-sm md:text-lg text-gray-600 mb-6 max-w-xl mx-auto lg:mx-0" data-id="element-162">
              Tu año completo de Pilates listo: clases, técnica, progresión,
              elementos, gestión y comunicación. Sin improvisar.
            </p>

            <div className="flex flex-wrap justify-center lg:justify-start gap-2 mb-6" data-id="element-163">
              <div className="flex items-center gap-1.5 bg-white px-3 py-1.5 rounded-lg shadow-sm border border-gray-100" data-id="element-164">
                <FileText className="w-4 h-4 text-sage" data-id="element-165" />
                <span className="text-xs font-medium" data-id="element-166">PDF digital</span>
              </div>
              <div className="flex items-center gap-1.5 bg-white px-3 py-1.5 rounded-lg shadow-sm border border-gray-100" data-id="element-167">
                <Zap className="w-4 h-4 text-gold" data-id="element-168" />
                <span className="text-xs font-medium" data-id="element-169">Acceso inmediato</span>
              </div>
              <div className="flex items-center gap-1.5 bg-white px-3 py-1.5 rounded-lg shadow-sm border border-gray-100" data-id="element-170">
                <Users className="w-4 h-4 text-sage" data-id="element-171" />
                <span className="text-xs font-medium" data-id="element-172">Todos los niveles</span>
              </div>
            </div>

            <motion.a href="#pricing" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="inline-flex items-center justify-center w-full sm:w-auto px-6 py-3.5 text-base font-bold text-white bg-sage hover:bg-sage-600 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300" data-id="element-173">
              💥 → QUIERO MI PILATES 360 AHORA
            </motion.a>

            <div className="mt-5 flex flex-wrap justify-center lg:justify-start gap-4 text-xs text-gray-500" data-id="element-174">
              <div className="flex items-center gap-1" data-id="element-175">
                <ShieldCheck className="w-3.5 h-3.5 text-sage" data-id="element-176" />
                <span data-id="element-177">Garantía 7 días</span>
              </div>
              <div className="flex items-center gap-1" data-id="element-178">
                <Lock className="w-3.5 h-3.5 text-sage" data-id="element-179" />
                <span data-id="element-180">Pago 100% seguro</span>
              </div>
              <div className="flex items-center gap-1" data-id="element-181">
                <CreditCard className="w-3.5 h-3.5 text-sage" data-id="element-182" />
                <span data-id="element-183">Mercado Pago | Tarjeta</span>
              </div>
            </div>
          </motion.div>

          {/* Desktop-only right column mockup */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative hidden lg:block" data-id="element-184">
            <div className="absolute inset-0 bg-sage-200 rounded-full blur-3xl opacity-30 animate-pulse" data-id="element-185"></div>
            <img src="https://cdn.magicpatterns.com/uploads/qgYL8YsPZ4NwKd6D4QHx5S/hf_20260408_025308_a29afd08-5343-4eda-a650-8ce65bca8982-Photoroom.png" alt="Pilates 360 MegaPack Mockup" className="relative z-10 w-[70%] max-w-md mx-auto drop-shadow-2xl" data-id="element-186" />
          </motion.div>
        </div>
      </div>
    </section>;
};